import { render, staticRenderFns } from "./BlockModal.vue?vue&type=template&id=7c7f0242&scoped=true&"
import script from "./BlockModal.vue?vue&type=script&lang=ts&"
export * from "./BlockModal.vue?vue&type=script&lang=ts&"
import style0 from "./BlockModal.vue?vue&type=style&index=0&id=7c7f0242&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c7f0242",
  null
  
)

export default component.exports